<template>
  <v-container fluid class="pt-12 section-request-demo grey lighten-4" style="padding-top: 100px; padding-bottom: 0px;">

    <v-row class="title font-weight-medium text-center">
      <v-col>
        <p class="grey--text text--darken-3">
          <v-icon class="blink" color="primary">mdi-color-helper</v-icon>Your payment <span class="primary--text font-weight-bold">succeeded</span>. Thank you !<br/> Redirecting in 5 seconds...
        </p>
      </v-col>
    </v-row>

    <!-- Allah'Snackbar -->
    <v-snackbar v-model="snack" :timeout="5000" :color="snackColor" dense>
      {{ snackText }}
      <v-btn text @click="snack = false">Close</v-btn>
    </v-snackbar>

    <sec-diagonal v-model="this.$diagonal.bottom"></sec-diagonal>
  </v-container>
</template>

<script>

import SecDiagonal from '@/components/pages/public/SecDiagonal';

export default {
  name: "SubscriptionSuccess",
  components: {
    SecDiagonal
  },
  data: () => ({
    snack: false,
    snackColor: '',
    snackText: '',
  }),
  mounted() {
    this.$api.get('/api/auth/subscriptions/sync').then(res => {
      if (res && res.status === 200) {
        this.snack = true;
        this.snackColor = 'success';
        this.snackText = 'Subscriptions successfully synced';
      }
    }).catch(() => {
      this.snack = true;
      this.snackColor = 'error';
      this.snackText = 'Unable to retreive user\'s info';
    });
    setTimeout("window.location.href=\"/portal/home\";", 5000);
  },
  watch: {
  },
  methods: {
  }
};
</script>

<style scoped>
</style>
